import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { AuthService } from '../shared/services/auth.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class InventoryService {

  private _showAddForm = new Subject<boolean>();
  showAddForm$ = this._showAddForm.asObservable();
  private _showOrderForm = new Subject<boolean>();
  showOrderForm$ = this._showOrderForm.asObservable();
  private _rowReady = new Subject<any>();
  rowReady$ = this._rowReady.asObservable();
  private _itemReady = new Subject<any>();
  itemReady$ = this._itemReady.asObservable();
  private _showView = new Subject<boolean>();
  showView$ = this._showView.asObservable();
  private _barCode = new Subject<string>();
  barCode$ = this._barCode.asObservable();
  private _showScan = new Subject<boolean>();
  showScan$ = this._showScan.asObservable();
  private _poReady = new Subject<any>();
  poReady$ = this._poReady.asObservable();
  private _editReady = new Subject<any>();
  editReady$ = this._editReady.asObservable();
  private _tabletItem:any;

  private _slabTypes:string[] = [
    'Full', 'Partial'
  ];

  private _inventoryTypes:string[] = [
    'Petrafab Stock', 'Remnant', 'For a Job', 'Hold For Customer', 'Hold For Estimating'
  ];

  private _finishes:string[] = [
    'Brushed', 'Honed', 'Leather', 'Polished',  'Suede','Volcano', 'Concrete'
  ];

  private _thicks:number[] = [
    .3,.6,1,1.2,2,3,5
  ];

  private _lShapes:string[] = [
    'left','right'
  ];

  private _statuses:string[] = [
    'Active','Deleted','Trash'
  ];

  private _saws:string[] = [
    'SASSO','EURO'
  ];

  private _lists:any[];

  constructor(
    private _http:Http,
    private _authService:AuthService
  ) { }

  addRow(row):void {
    this._rowReady.next(row);
  }

  viewItem(item):void {
    this._itemReady.next(item);
  }

  setAddShow(showAddForm: boolean): void {
    this._showAddForm.next(showAddForm);
  }

  setOrderShow(toShow: boolean): void {
    this._showOrderForm.next(toShow);
  }
  setViewShow(v: boolean): void {
    this._showView.next(v);
  }

  setBarCode(b: string): void {
    this._barCode.next(b);
  }

  setShowScan(scan: boolean): void {
    this._showScan.next(scan);
  }

  setPOReady(res) {
    this._poReady.next(res);
  }

  setEditReady(item) {
    this._editReady.next(item);
  }

  getInventory(filters) {
    const url = `${environment.apiUrl}inventory/list`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {filter:filters}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw('Error')
      })
  }

  quickSearch(filters) {
    const url = `${environment.apiUrl}inventory/search`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {filter:filters}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw('Error')
      })
  }

  export(filters) {
    const url = `${environment.apiUrl}inventory/export`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {filter:filters}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw('Error')
      })
  }

  getOnSaws() {
    const url = `${environment.apiUrl}inventory/onsaws`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw('Error')
      })
  }

  getDetail(barcode) {
    const url = `${environment.apiUrl}inventory`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {barcode:barcode}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw('Error')
      })
  }

  getLists() {
    const url = `${environment.apiUrl}inventory/addLists`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
      .map( (resp: Response) => {
        this._lists = resp.json();
        return this._lists;
      })
      .catch( (error: any) =>  {
        return Observable.throw('Error')
      })
  }

  getInventoryTypes() {
    return this._inventoryTypes;
  }

  getSlabTypes() {
    return this._slabTypes;
  }

  getFinishes() {
    return this._finishes;
  }

  getThicks() {
    return this._thicks;
  }

  getLShapes() {
    return this._lShapes;
  }

  getStatuses() {
    return this._statuses;
  }

  getSaws() {
    return this._saws;
  }

  setTabletItem(i) {
    this._tabletItem = i;
  }

  update(form) {
    let url = `${environment.apiUrl}inventory/update`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: form, user: this._authService.getUser()}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  create(form) {
    let url = `${environment.apiUrl}inventory/create`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: form, user: this._authService.getUser()}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  order(form) {
    let url = `${environment.apiUrl}inventory/order`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: form, user: this._authService.getUser()}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  printLabel(item, printer) {
    const url = `${environment.apiUrl}inventory/printLabel`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item, printer: printer}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }


  closeJob(item) {
    const url = `${environment.apiUrl}inventory/closeJob`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  reOpenJob(item) {
    const url = `${environment.apiUrl}inventory/reOpenJob`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  trash(item) {
    const url = `${environment.apiUrl}inventory/trash`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  received(item) {
    const url = `${environment.apiUrl}inventory/received`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  move(item) {
    const url = `${environment.apiUrl}inventory/move`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  moveToSaw(item) {
    const url = `${environment.apiUrl}inventory/saw`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  cut(item, formData, saw, printer) {
    const url = `${environment.apiUrl}inventory/cut`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {original: item, user:this._authService.getUser(), cut:formData, saw:saw, printer:printer}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  sawyer(item, formData) {
    const url = `${environment.apiUrl}inventory/sawyer`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {original: item, sawyer :formData}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  startCut(item) {
    const url = `${environment.apiUrl}inventory/cut/start`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {item: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  stopCut(item) {
    const url = `${environment.apiUrl}inventory/cut/stop`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {item: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  delete(item) {
    const url = `${environment.apiUrl}inventory/delete`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: item}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  saveAndPrint(data, printer) {
    let url = `${environment.apiUrl}inventory/excel`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {inventory: data, printer: printer}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  getHistory(item) {
    let url = `${environment.apiUrl}inventory/history/${item._id}`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/inventory.service.ts